import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../services/api';

interface UpdateProfileData {
  firstName?: string;
  lastName?: string;
  avatar?: string | null;
  avatarColor?: string;
  phone?: string;
  timezone?: string;
  bio?: string;
}

export function useUpdateProfile() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: UpdateProfileData) => {
      const response = await api.patch('/users/me', data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['auth', 'user'] });
    },
  });
}

export function useUpdateAvatarColor() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (color: string) => {
      const response = await api.patch('/users/me/avatar-color', { color });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['auth', 'user'] });
    },
  });
}

interface BusinessHour {
  dayOfWeek: number;
  startTime: string;
  endTime: string;
  isEnabled: boolean;
}

interface UpdateOrgSettingsData {
  timezone?: string;
  businessHours?: BusinessHour[];
}

export function useUpdateOrganizationSettings() {
  return useMutation({
    mutationFn: async (data: UpdateOrgSettingsData) => {
      const response = await api.patch('/users/organization/settings', data);
      return response.data;
    },
  });
}
